import { render, staticRenderFns } from "./Credentialer.vue?vue&type=template&id=0d560af0"
import script from "./Credentialer.vue?vue&type=script&lang=js"
export * from "./Credentialer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports